import React from 'react';
import cmsUtils from '../../utils/cmsUtils';
import utils from '../../../utils';
import { SiteLink } from '../../../components';

export function PageTilesSmall(props) {
  const item = props.item;
  const cmsOption = props.cmsOption || {};

  const pages = getPages(cmsUtils.payload(item, 'PageObjects'))
  const pageTileElts = pages.map((page, index) =>
    <Tile page={page} key={index} disableLink={cmsOption.isCmsEdit} index={index}></Tile>
  );

  const cssClass = utils.classNames('cms_item', item.cssClass || item.anchorName || '');

  return (
    <div className={cssClass} data-cms-item-id={cmsOption.isCmsEdit && item.itemId} id={item.anchorName}>
      <div className="page-tiles tiles main">
        {pageTileElts}
      </div>
    </div>
  );
}

function getPages(pagesSerialized) {
  if (pagesSerialized) {
    return JSON.parse(pagesSerialized);
  }
  return [];
}

function Tile(props) {
  const page = props.page;
  const imageUrl = utils.site.resourcePath(page.imageUrl);
  const disableLink = props.disableLink;
  const index = props.index;
  
  return (
    <div className="page-tile tile" style={{'--tile-index': index}}>
      <SiteLink className="tile-link" to={disableLink ? '' : page.pageUrl}>
        <div 
          className="bg" 
          style={{ backgroundImage: `url(${imageUrl})` }}
        ></div>
        <div className="wrapper">
          <h3 className="title">
            {page.pageTitle}
          </h3>
        </div> 
      </SiteLink>
    </div>
  )
}
